import RoutePathEnum from "../enums/RoutePathEnum";
import ModalNameEnum from "../enums/ModalNameEnum";
import PlatformSlugEnum from "../enums/PlatformSlugEnum";
import Scopes from "../enums/ScopeEnum";

export default {
    RoutePathEnum: RoutePathEnum,
    ModalNameEnum: ModalNameEnum,
    PlatformSlugEnum: PlatformSlugEnum,
    ScopesEnum: Scopes,
};
